import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {NgbDropdown, NgbDropdownMenu, NgbDropdownToggle} from '@ng-bootstrap/ng-bootstrap';
import {AuthStorageService, AuthToken, User} from '@spartacus/core';
import {Observable, of} from 'rxjs';
import {first, switchMap} from 'rxjs/operators';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {isPlatformBrowser} from '@angular/common';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {DcpBaselineAuthService} from '@app/auth/services/dcp-baseline-auth.service';
import {SessionStorageService} from '@dcp/configurator';

@UntilDestroy()
@Component({
  selector: 'dcp-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent implements OnInit {
  @ViewChild(NgbDropdown) dropdown: NgbDropdown;
  @ViewChild(NgbDropdownToggle, {static: false}) dropdownToggle: NgbDropdownToggle;
  @ViewChild(NgbDropdownMenu, {static: false}) dropdownMenu: NgbDropdownMenu;
  @ViewChild('userMenuDropdown', {static: false}) userMenuDropdown: ElementRef;
  @ViewChild('ngbDropdown', {static: false}) ngbDropdown: ElementRef;
  public dropdownStateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  userToken$: Observable<AuthToken>;
  user$: Observable<User>;
  loginAction: string = 'LoginAction';
  dropdownOpenAction: string = 'DropdownOpenAction';

  public isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    public authService: DcpAuthService,
    private userFacade: UserAccountFacade,
    private changeDetector: ChangeDetectorRef,
    private sessionStorageService: SessionStorageService,
    protected authStorageService: AuthStorageService,
    private baselineAuthService: DcpBaselineAuthService
  ) {
  }

  get highlighted(): boolean {
    return this.dropdown && this.dropdown.isOpen();
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.userToken$ = this.authStorageService.getToken();
      this.user$ = this.getLoggedInUser();
    }
  }

  dropDownOpenAction(event: boolean): void {
    this.dropdownStateChanged.emit(event);
  }

  closeDropdown(): void {
    if (this.dropdown) {
      this.dropdown.close();
    }
  }

  loginLogoutRequest(): void {
    this.closeDropdown();
    this.userToken$.pipe(first(), untilDestroyed(this)).subscribe((response) => {
      if (response.access_token) {
        this.baselineAuthService.logout();
      } else {
        this.sessionStorageService.setItem('loginMethod', 'manual');
        this.authService.login();
        this.changeDetector.detectChanges();
      }
    });
  }

  onKeyDown(event: KeyboardEvent, action: string): void {
    if (event.key === 'Enter' || event.key === 'NumpadEnter') {
      if (action === this.loginAction) {
        this.loginLogoutRequest();
      } else if (action === this.dropdownOpenAction && this.dropdown) {
        this.dropdown.open();
      }
    }
  }

  /**
   * Determines if a user is logged in.
   *
   * @returns an Observable with undefined if no user is logged in. or an Observable with the user.
   */
  private getLoggedInUser() {
    return this.authService.isUserLoggedIn().pipe(
      switchMap(isUserLoggedIn => {
        if (isUserLoggedIn) {
          return this.userFacade.get();
        } else {
          return of(undefined);
        }
      }),
    );
  }
}
